import React, {useContext, useEffect, useState} from 'react';
import LogosContext from "app/react/components/logos/LogosContext";
import useHoverContent from 'app/react/hooks/useHoverContent'

export default function Logo (props) {

  const { buttonTexts, selectedOption }  = useContext(LogosContext)
  const [logo, setLogo] = useState(null)

  const { hoverClass, hoverContent } = useHoverContent({
    url: logo && logo.img ? logo.img.url : '',
    copyText: buttonTexts.copy,
    downloadText: buttonTexts.download
  })

  useEffect(() => {
    setLogo(props.logos[selectedOption])
  }, [selectedOption])

  if (!logo || logo.img === null) return

  return (
    <div className={'dm-secondary-logo dm-hover-content ' + hoverClass}>
      <div className="dm-secondary-logo__image-container" style={{ background: props.bgColor }}>
        <img src={logo.img.url} alt={logo.img.alt} />
        {hoverContent()}
      </div>
      <div className="dm-secondary-logo__text-container">
        {props.title && (
          <div className="dm-secondary-logo__title">{props.title}</div>
        )}
        {logo.text && (
          <div className="dm-secondary-logo__text" dangerouslySetInnerHTML={{ __html: logo.text }} />
        )}
      </div>
    </div>
  )
}